var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneSync = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56.128 7.6H23.872a3.437 3.437 0 0 0-3.437 3.438v58.126a3.437 3.437 0 0 0 3.437 3.437h32.256a3.437 3.437 0 0 0 3.437-3.437V11.038A3.437 3.437 0 0 0 56.128 7.6Z",
  stroke: "#999EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.435 14.9h39.13m-39.13 50.4h39.13M41.9 49.84a9.917 9.917 0 0 0 5.113-16.747m-8.9-2.732a9.937 9.937 0 0 0-5.126 16.758m12.946-12.946-2.641 2.641v-7.26l7.246.014-2.628 2.628-1.977 1.977ZM34.08 46.026l2.628-2.628.014 7.248H29.46l2.642-2.642 1.978-1.978Z",
  stroke: "#999EBF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneSync);
export default ForwardRef;